import { getStorageByKey, setStorageValueByKey } from './localStorage';
import { getUrlParams } from '@/utils/url';

const CUSTOMIZER_TOOLTIP_USER = 'customizer_tooltip_user_';
export const storageCustomizerTooltipView = {
  get: userId => {
    if (!userId) return;
    return getStorageByKey(`${CUSTOMIZER_TOOLTIP_USER}${userId}`);
  },
  set: (userId, value = true) => {
    if (!userId) return;

    setStorageValueByKey(`${CUSTOMIZER_TOOLTIP_USER}${userId}`, value);
  },
};

export const getUrlRulesToCustomizer = () => {
  const params = location?.search || '';
  const urlParams = getUrlParams(params);
  const list = (urlParams.get('hide') || '').split(',') || [];

  return {
    // Скрытие иконки лк
    isHiddenLinkAccount: list.includes('l'),
    // Скрытие блока размера
    isHiddenTooltipSize: list.includes('c'),
  };
};

const getListModelItemByKey = (item, key) => {
  return item?.items?.length > 1
    ? Array.isArray(item?.value?.series)
      ? item?.value[key]
      : item?.value.series[key]
    : item?.value[key];
};

export const getListModel = (items = []) => {
  let sort = 1;
  const obj = items.reduce((acc, value) => {
    if (Array.isArray(value.series)) {
      const key = value.name;
      if (key) {
        acc[key] = {
          value,
          items: [...value.sub_models],
          sort,
        };

        sort++;
      }
    } else if (value.series) {
      const key = value.series.id;
      if (key) {
        if (acc[key]) {
          acc[key].items.push(value);
        } else {
          acc[key] = {
            value,
            items: [value],
            sort,
          };

          sort++;
        }
      }
    } else {
      const key = value.name;
      acc[key] = {
        value,
        items: [value],
        sort,
      };

      sort++;
    }

    return acc;
  }, {});

  const list = Object.values(obj)
    .map(item => ({
      id: getListModelItemByKey(item, 'id'),
      title: getListModelItemByKey(item, 'name'),
      ...item,
    }))
    .sort((a, b) => a.sort - b.sort);

  return list;
};
